module.exports = __webpack_public_path__ + "media/images/plans/photo_location/photo_location-1-2-4544c565962953d734f8afb5dccb04c4.png";